module.exports = __webpack_public_path__ + "h5/img/cards.16744b00.png";